import scenes from './scenes.module'
export default scenes
